import {
	branchActions,
	branchErrorSelector,
	branchFilterSelector,
	branchItemsSelector,
	branchLoadingSelector,
	branchPaginationSelector
} from "../branchSlice";
import {useDispatch, useSelector} from "react-redux";
import {useContext, useEffect, useState} from "react";
import {notification} from "antd";
import {
	Button,
	Loading,
	Modal,
	Icon
} from "~/components";
import {
	BranchFormAddEdit,
	BranchTable
} from "../components";
import {
	apiError,
	handleRequest
} from "~/utils";
import {useCan} from "~/hooks";
import {DATA_LIMIT_KEY} from "~/app/constants";
import {AppContext} from "~/context/AppProvider";
import {branchApi} from "~/api";

function Branch() {

	const {country} = useContext(AppContext);

	const can = {
		add: useCan('shop_branch_add'),
		edit: useCan('shop_branch_edit'),
		delete: useCan('shop_branch_delete'),
	}

	const dispatch = useDispatch();

	const items = useSelector(branchItemsSelector);

	const loading = useSelector(branchLoadingSelector);

	const error = useSelector(branchErrorSelector);

	const pagination = useSelector(branchPaginationSelector);

	const filter = useSelector(branchFilterSelector);

	const [itemEdit, setItemEdit] = useState({});

	//Modal show
	const [openModal, setOpenModal] = useState({
		addEdit : false,
		default  : false,
		delete  : false,
	});

	const handleModalOpen = (modal) => {
		openModal[modal] = true;
		setOpenModal({...openModal})
	}

	const handleModalClose = (modal) => {
		openModal[modal] = false;
		setOpenModal({...openModal});
	}

	//Load data
	useEffect(() => {
		dispatch(branchActions.fetchData(filter));
	}, [filter]);

	if (error) {
		notification.error({message: 'Lỗi', description: error});
	}

	//Add Edit
	const handleSaveItem = async (data, isEdit) => {
		let messageAction = 'Thêm mới';
		if(isEdit) {
			if (itemEdit?.id == 'undefined') {
				notification.error({message: 'Lỗi', description: 'Không có thông tin điểm lấy hàng để cập nhật'});
				return;
			}
			data.id = itemEdit.id;
			messageAction = 'Cập nhật';
		}
		let [error, response] = (isEdit) ? await handleRequest(branchApi.update(data)) : await handleRequest(branchApi.add(data));
		let message = apiError(`${messageAction} điểm lấy hàng thất bại`, error, response);
		if(!message) {
			notification.success({message: 'Thành công', description: `${messageAction} điểm lấy hàng thành công`});
			if(!isEdit) {
				dispatch(branchActions.add(response.data));
			}
			else {
				dispatch(branchActions.update(response.data));
			}
			handleModalClose('addEdit')
		}
	}

	//Delete
	const handleDelete = async () => {
		if (itemEdit?.id == 'undefined') {
			notification.error({message: 'Lỗi', description: 'Không có điểm lấy hàng để xóa'});
			return;
		}
		let [error, response] = await handleRequest(branchApi.delete(itemEdit.id));
		let message = apiError(`xóa điểm lấy hàng thất bại`, error, response);
		if(!message) {
			notification.success({message: 'Thành công', description: `xóa điểm lấy hàng thành công`});
			dispatch(branchActions.delete(itemEdit.id));
			handleModalClose('delete')
		}
	}

	//default
	const handleDefault = async () => {
		if (itemEdit?.id == 'undefined') {
			notification.error({message: 'Lỗi', description: 'Không có điểm lấy hàng để đặt làm mặc định'});
			return;
		}
		let [error, response] = await handleRequest(branchApi.default(itemEdit.id));
		let message = apiError(`Cập nhật điểm lấy hàng thất bại`, error, response);
		if(!message) {
			notification.success({message: 'Thành công', description: `Cập nhật điểm lấy hàng thành công`});
			dispatch(branchActions.fetchData(filter));
			handleModalClose('default')
		}
	}

	const handlePaginationChange = (page) => {
		dispatch(branchActions.setFilter({...filter, page }));
	}

	const handleLimitChange = (value) => {
		localStorage.setItem(DATA_LIMIT_KEY, value)
		dispatch(branchActions.setFilter({
			...filter,
			limit: value,
			page: 1
		}));
	};

	return (
		<div className={'container'}>
			<section>{can.add && <Button outline leftIcon={Icon.plusCircle} onClick={() => {setItemEdit({});handleModalOpen('addEdit')}}>Thêm mới</Button>}</section>
			<section>
				{loading && <Loading/>}
				{items && <BranchTable
					items={items}
					onPaginationChange={handlePaginationChange}
					onLimitChange={handleLimitChange}
					setItemEdit={setItemEdit}
					openModal={handleModalOpen}
					pagination={pagination}
					can={can}
					country={country}
				/>}
			</section>
			{
				(can.add || can.edit) && <Modal title="Địa điểm lấy hàng" visible={openModal.addEdit} onCancel={() => {handleModalClose('addEdit')}}>
					<BranchFormAddEdit country={country} item={itemEdit} onHandleSubmit={handleSaveItem} />
				</Modal>
			}
			{
				(can.delete && itemEdit?.id) && <Modal title="Xóa điểm lấy hàng" visible={openModal.delete} onCancel={() => {handleModalClose('delete')}}>
					<p>Bạn muốn xóa điểm lấy hàng <b>{itemEdit?.name}</b>?</p>
					<div className="d-flex justify-content-end gap modal-bottom pd-1">
						<Button white leftIcon={Icon.close} onClick={() => {handleModalClose('delete')}}> Đóng </Button>
						<Button primary leftIcon={Icon.delete} onClick={handleDelete}> Xóa </Button>
					</div>
				</Modal>
			}
			{
				(can.edit && itemEdit?.id) && <Modal title="Đặt điểm lấy hàng mặc định" visible={openModal.default} onCancel={() => {handleModalClose('default')}}>
					<p>Bạn muốn đặt <b>{itemEdit?.name}</b> thành điểm lấy hàng mặc định?</p>
					<div className="d-flex justify-content-end gap modal-bottom pd-1">
						<Button white leftIcon={Icon.close} onClick={() => {handleModalClose('default')}}> Đóng </Button>
						<Button background blue leftIcon={Icon.success} onClick={handleDefault}> Xác nhận </Button>
					</div>
				</Modal>
			}
		</div>
	)
}

export default Branch;